"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICNSQueriesImpl = exports.ICNSQueries = void 0;
const names_1 = require("./names");
exports.ICNSQueries = {
    use() {
        return (queriesSetBase, kvStore, chainId, chainGetter) => {
            return {
                icns: new ICNSQueriesImpl(queriesSetBase, kvStore, chainId, chainGetter),
            };
        };
    },
};
class ICNSQueriesImpl {
    constructor(_base, kvStore, chainId, chainGetter) {
        this.queryICNSNames = new names_1.ObservableQueryICNSNames(kvStore, chainId, chainGetter);
    }
}
exports.ICNSQueriesImpl = ICNSQueriesImpl;
//# sourceMappingURL=queries.js.map